import { render, staticRenderFns } from "./ReportsColumnDistributedChart.vue?vue&type=template&id=5b923f9a"
import script from "./ReportsColumnDistributedChart.vue?vue&type=script&lang=js"
export * from "./ReportsColumnDistributedChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports